"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2141],{

/***/ 2141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* reexport */ FloatingGroup_FloatingGroup; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(1987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@design-system-pc-virtual-afbb573c04/0/cache/@design-system-pc-npm-4.9.2-212883532c-eb3e5c3730.zip/node_modules/@design-system/pc/dist/design-system-pc.js
var design_system_pc = __webpack_require__(2372);
// EXTERNAL MODULE: ./src/components/LoadImage/index.tsx + 1 modules
var LoadImage = __webpack_require__(7119);
// EXTERNAL MODULE: ../../.yarn/unplugged/styled-components-virtual-24edae5a63/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(278);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/router.js
var next_router = __webpack_require__(1975);
// EXTERNAL MODULE: ../../.yarn/cache/nookies-npm-2.5.2-691fdd44ab-4cc6fd8d0a.zip/node_modules/nookies/dist/index.js
var dist = __webpack_require__(4752);
// EXTERNAL MODULE: ../../.yarn/cache/date-fns-npm-2.29.3-fef7e3c72c-e01cf5b62a.zip/node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(426);
// EXTERNAL MODULE: ../../.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/lodash.js
var lodash = __webpack_require__(5735);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
;// CONCATENATED MODULE: ./src/components/FloatingGroup/FloatingButtons/hooks/useRecentGoodsButton.tsx





var NAME_OF_RECENT_GOODS_BANNER_COOKIE = "HS_RECENT_STORE_GDS_FIRST_BANNER_VIEW";
var NAME_OF_RECENT_GOODS_IMAGE_URL_COOKIE = "HS_RECENT_STORE_GDS_IMAGE_URL";
var useRecentGoodsButton = function() {
    var router = (0,next_router.useRouter)();
    var cookies = (0,dist.parseCookies)();
    var ref = (0,react.useState)(false), isInit = ref[0], setIsInit = ref[1];
    var ref1 = (0,react.useState)(""), recentGdsImageUrl = ref1[0], setRecentGdsImageUrl = ref1[1];
    var ref2 = (0,react.useState)(false), isOpenRecentBanner = ref2[0], setIsOpenRecentBanner = ref2[1];
    var recentGoodsImageUrl = (0,react.useMemo)(function() {
        return lodash_default().trim(decodeURIComponent(lodash_default().get(cookies, NAME_OF_RECENT_GOODS_IMAGE_URL_COOKIE, "")));
    }, [
        cookies
    ]);
    var recentGoodsBannervalue = (0,react.useMemo)(function() {
        return lodash_default().trim(decodeURIComponent(lodash_default().get(cookies, NAME_OF_RECENT_GOODS_BANNER_COOKIE, "")));
    }, [
        cookies
    ]);
    var handleGoRecentGoodsPage = (0,react.useCallback)(function() {
        router.push("".concat("https://mall.hanssem.com/m", "//mmypage/recentlyLookGoodsList.do"));
    }, [
        router
    ]);
    var setStateByCookie = (0,react.useCallback)(function() {
        setRecentGdsImageUrl(recentGoodsImageUrl);
        setIsOpenRecentBanner(recentGoodsBannervalue !== "Y");
    }, [
        recentGoodsBannervalue,
        recentGoodsImageUrl
    ]);
    var setRecentBannerViewCookie = (0,react.useCallback)(function() {
        (0,dist.setCookie)(null, NAME_OF_RECENT_GOODS_BANNER_COOKIE, "Y", {
            domain: "".concat(".hanssem.com"),
            path: "/",
            expires: (0,addDays/* default */.Z)(new Date(), 1),
            httpOnly: false
        });
    }, []);
    var handleCloseRecentBanner = (0,react.useCallback)(function() {
        setTimeout(function() {
            setIsOpenRecentBanner(false);
        }, 3000);
    }, []);
    (0,react.useEffect)(function() {
        if (isInit) return;
        setStateByCookie();
        if (recentGoodsBannervalue !== "Y" && recentGoodsImageUrl) {
            setRecentBannerViewCookie();
            handleCloseRecentBanner();
        }
        setIsInit(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        recentGdsImageUrl: recentGdsImageUrl,
        isOpenRecentBanner: isOpenRecentBanner,
        handleGoRecentGoodsPage: handleGoRecentGoodsPage
    };
};
/* harmony default export */ var hooks_useRecentGoodsButton = (useRecentGoodsButton);

// EXTERNAL MODULE: ./src/services/tracking.ts
var tracking = __webpack_require__(9676);
;// CONCATENATED MODULE: ./src/components/FloatingGroup/FloatingButtons/RecentGoodsButton.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 0;\n  bottom: ",
        ";\n  transition: bottom 0.4s ease, width 0.3s;\n  cursor: pointer;\n\n  &:hover {\n    width: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var FOLDED_WIDTH = 80;
var OPEN_WIDTH = 181;
var BORDER_RATIO = 18 / 35;
var RecentGoodsButton = function(param) {
    var isShowTopButton = param.isShowTopButton;
    var ref = hooks_useRecentGoodsButton(), recentGdsImageUrl = ref.recentGdsImageUrl, isOpenRecentBanner = ref.isOpenRecentBanner, handleGoRecentGoodsPage = ref.handleGoRecentGoodsPage;
    var computedBorderRadius = (0,react.useMemo)(function() {
        return FOLDED_WIDTH * BORDER_RATIO;
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: recentGdsImageUrl && /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecentGoodsWrapper, _objectSpreadProps(_objectSpread({
            overflow: "hidden",
            width: isOpenRecentBanner ? "".concat(OPEN_WIDTH, "px") : "".concat(FOLDED_WIDTH, "px"),
            borderRadius: computedBorderRadius,
            boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.15)",
            onClick: handleGoRecentGoodsPage,
            zIndex: 1,
            isShowTopButton: isShowTopButton
        }, tracking/* default.tagGTM */.Z.tagGTM("recent_goods_floating_button")), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* HStack */.zn, {
                    width: OPEN_WIDTH,
                    height: FOLDED_WIDTH,
                    backgroundColor: "color_chip.primary",
                    pl: 16,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                        variant: "headline5",
                        color: "color_chip.white",
                        children: "최근 본 상품"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                    width: FOLDED_WIDTH,
                    height: FOLDED_WIDTH,
                    backgroundColor: "color_chip.primary",
                    border: "2px solid",
                    borderColor: "color_chip.primary",
                    overflow: "hidden",
                    borderRadius: computedBorderRadius,
                    position: "absolute",
                    top: "0",
                    right: "0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadImage/* default */.Z, {
                        src: recentGdsImageUrl,
                        w: FOLDED_WIDTH,
                        h: FOLDED_WIDTH,
                        c: true
                    })
                })
            ]
        }))
    });
};
var RecentGoodsWrapper = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "RecentGoodsButton__RecentGoodsWrapper",
    componentId: "sc-e8905919-0"
})(_templateObject(), function(param) {
    var isShowTopButton = param.isShowTopButton;
    return isShowTopButton ? "62px" : 0;
}, OPEN_WIDTH);
/* harmony default export */ var FloatingButtons_RecentGoodsButton = (RecentGoodsButton);

;// CONCATENATED MODULE: ./src/components/FloatingGroup/FloatingButtons/ConsultButton.tsx
function ConsultButton_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ConsultButton_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ConsultButton_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ConsultButton_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function ConsultButton_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ConsultButton_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function ConsultButton_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ConsultButton_templateObject() {
    var data = ConsultButton_taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 0;\n  bottom: ",
        ";\n  transition: bottom 0.4s ease;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);\n  cursor: pointer;\n"
    ]);
    ConsultButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var ConsultButton = function(param) {
    var isShowTopButton = param.isShowTopButton;
    var router = (0,next_router.useRouter)();
    var handleGoQuickConsult = (0,react.useCallback)(function() {
        router.push("/seq-consult?channelType=OP11_02");
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsultButtonWrapper, ConsultButton_objectSpreadProps(ConsultButton_objectSpread({
        width: 72,
        height: 72,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "color_chip.primary",
        onClick: handleGoQuickConsult,
        isShowTopButton: isShowTopButton
    }, tracking/* default.tagGTM */.Z.tagGTM("quick_consult_button")), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Text */.xv, {
            variant: "headline7",
            color: "color_chip.white",
            textAlign: "center",
            children: [
                "무료",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "견적 상담"
            ]
        })
    }));
};
var ConsultButtonWrapper = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "ConsultButton__ConsultButtonWrapper",
    componentId: "sc-caa0f4a5-0"
})(ConsultButton_templateObject(), function(param) {
    var isShowTopButton = param.isShowTopButton;
    return isShowTopButton ? "62px" : 0;
});
/* harmony default export */ var FloatingButtons_ConsultButton = (ConsultButton);

// EXTERNAL MODULE: ./src/styles/index.ts
var styles = __webpack_require__(2655);
;// CONCATENATED MODULE: ./src/components/FloatingGroup/FloatingButtons/hooks/useFloatingTopButton.tsx


var useFloatingTopButton = function(param) {
    var handleIsShowTopButton = param.handleIsShowTopButton;
    var rootRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(0), scrollY = ref[0], setScrollY = ref[1];
    var handleClickScrollTop = (0,react.useCallback)(function() {
        if (!(rootRef === null || rootRef === void 0 ? void 0 : rootRef.current)) return;
        rootRef.current.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, []);
    var handleWatchScroll = (0,lodash.throttle)(function() {
        var ref;
        var ref1;
        var currentScrollY = (ref1 = rootRef === null || rootRef === void 0 ? void 0 : (ref = rootRef.current) === null || ref === void 0 ? void 0 : ref.scrollY) !== null && ref1 !== void 0 ? ref1 : 0;
        setScrollY(currentScrollY);
    }, 300);
    var handleChangeButtonExposure = (0,react.useCallback)(function() {
        var exposurePoint = (window === null || window === void 0 ? void 0 : window.innerHeight) / 3;
        handleIsShowTopButton(scrollY > exposurePoint);
    }, [
        handleIsShowTopButton,
        scrollY
    ]);
    var initScrollEvent = function() {
        rootRef.current = window;
        rootRef.current.addEventListener("scroll", handleWatchScroll);
    };
    var destroyScrollEvent = function() {
        if ((rootRef === null || rootRef === void 0 ? void 0 : rootRef.current) === null) return;
        rootRef.current.removeEventListener("scroll", handleWatchScroll);
    };
    (0,react.useEffect)(function() {
        initScrollEvent();
        return function() {
            destroyScrollEvent();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        handleChangeButtonExposure();
    }, [
        handleChangeButtonExposure
    ]);
    return {
        handleClickScrollTop: handleClickScrollTop
    };
};
/* harmony default export */ var hooks_useFloatingTopButton = (useFloatingTopButton);

;// CONCATENATED MODULE: ./src/components/FloatingGroup/FloatingButtons/FloatingTopButton.tsx
function FloatingTopButton_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FloatingTopButton_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FloatingTopButton_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function FloatingTopButton_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function FloatingTopButton_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        FloatingTopButton_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function FloatingTopButton_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function FloatingTopButton_templateObject() {
    var data = FloatingTopButton_taggedTemplateLiteral([
        "\n  transform: scale(",
        ");\n  transition: transform 0.2s;\n"
    ]);
    FloatingTopButton_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = FloatingTopButton_taggedTemplateLiteral([
        "\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var FloatingTopButton = function(param) {
    var isShowTopButton = param.isShowTopButton, handleIsShowTopButton = param.handleIsShowTopButton;
    var handleClickScrollTop = hooks_useFloatingTopButton({
        handleIsShowTopButton: handleIsShowTopButton
    }).handleClickScrollTop;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollTopButtonWrapper, FloatingTopButton_objectSpreadProps(FloatingTopButton_objectSpread({
        isShowTopButton: isShowTopButton,
        width: 52,
        height: 52,
        position: "absolute",
        right: "8px",
        bottom: "0"
    }, tracking/* default.tagGTM */.Z.tagGTM("scroll_top_button")), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollTopButton, {
            onClick: handleClickScrollTop,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* IconButton */.hU, {
                size: "xlg",
                variant: "ic_arrow_top"
            })
        })
    }));
};
/* harmony default export */ var FloatingButtons_FloatingTopButton = (FloatingTopButton);
var ScrollTopButtonWrapper = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "FloatingTopButton__ScrollTopButtonWrapper",
    componentId: "sc-73aac759-0"
})(FloatingTopButton_templateObject(), function(param) {
    var isShowTopButton = param.isShowTopButton;
    return isShowTopButton ? 1 : 0;
});
var ScrollTopButton = (0,styled_components_browser_esm/* default */.ZP)(design_system_pc/* Box */.xu).withConfig({
    displayName: "FloatingTopButton__ScrollTopButton",
    componentId: "sc-73aac759-1"
})(_templateObject1(), function(props) {
    return props.theme.colors.color_chip.white;
}, function(props) {
    return props.theme.colors.color_chip.gray[100];
});

;// CONCATENATED MODULE: ./src/components/FloatingGroup/FloatingGroup.tsx
function FloatingGroup_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FloatingGroup_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FloatingGroup_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function FloatingGroup_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function FloatingGroup_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        FloatingGroup_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var FloatingGroup = function(param) {
    var visibleConsultButton = param.visibleConsultButton, visibleRecentButton = param.visibleRecentButton, zIndex = param.zIndex;
    var ref = (0,react.useState)(false), isShowTopButton = ref[0], setIsShowTopButton = ref[1];
    var handleIsShowTopButton = (0,react.useCallback)(function(value) {
        setIsShowTopButton(value);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, FloatingGroup_objectSpreadProps(FloatingGroup_objectSpread({
        position: "fixed",
        right: 80,
        bottom: 40,
        zIndex: zIndex || styles/* TOP_BUTTON_Z_INDEX */.xH,
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    }, tracking/* default.tagGTM */.Z.tagGTM("floating_group")), {
        children: [
            visibleRecentButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingButtons_RecentGoodsButton, {
                isShowTopButton: isShowTopButton
            }),
            visibleConsultButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingButtons_ConsultButton, {
                isShowTopButton: isShowTopButton
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingButtons_FloatingTopButton, {
                isShowTopButton: isShowTopButton,
                handleIsShowTopButton: handleIsShowTopButton
            })
        ]
    }));
};
/* harmony default export */ var FloatingGroup_FloatingGroup = (FloatingGroup);

;// CONCATENATED MODULE: ./src/components/FloatingGroup/index.tsx




/***/ }),

/***/ 7119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ LoadImage_LoadImage; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(1861);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(1987);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(7748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/image.js
var next_image = __webpack_require__(257);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../.yarn/cache/react-merge-refs-npm-2.0.1-e038520c6a-c0b6fdb384.zip/node_modules/react-merge-refs/dist/index.mjs
var dist = __webpack_require__(6467);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@design-system-pc-virtual-afbb573c04/0/cache/@design-system-pc-npm-4.9.2-212883532c-eb3e5c3730.zip/node_modules/@design-system/pc/dist/design-system-pc.js
var design_system_pc = __webpack_require__(2372);
// EXTERNAL MODULE: ../../.yarn/unplugged/styled-components-virtual-24edae5a63/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(278);
;// CONCATENATED MODULE: ./src/components/LoadImage/LoadImage.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    width: 100%;\n    height: 100%;\n    object-fit: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







/**
 * 이미지가 로드가 완료된 이후에 노출
 * @author 이현우
 */ var LoadImage = /*#__PURE__*/ react.forwardRef(function LoadImage(_param, ref) {
    var src = _param.src, w = _param.w, h = _param.h, q = _param.q, c = _param.c, className = _param.className, _isNextImage = _param.isNextImage, isNextImage = _isNextImage === void 0 ? false : _isNextImage, _imgFit = _param.imgFit, imgFit = _imgFit === void 0 ? "fill" : _imgFit, objectFit = _param.objectFit, _imageScale = _param.imageScale, imageScale = _imageScale === void 0 ? 1 : _imageScale, _skeletonSize = _param.skeletonSize, _borderRadius = _param.borderRadius, borderRadius = _borderRadius === void 0 ? 0 : _borderRadius, props = _objectWithoutProperties(_param, [
        "src",
        "w",
        "h",
        "q",
        "c",
        "className",
        "isNextImage",
        "imgFit",
        "objectFit",
        "imageScale",
        "skeletonSize",
        "borderRadius"
    ]);
    var imageRef = (0,react.useRef)(null);
    var wrapperRef = (0,react.useRef)(null);
    var mergeRef = (0,dist/* mergeRefs */.l)([
        ref,
        imageRef
    ]);
    var _$ref = (0,react.useState)(null), aspectRatio = _$ref[0], setAspectRatio = _$ref[1];
    var _$ref1 = (0,react.useState)(false), imageLoaded = _$ref1[0], setImageLoaded = _$ref1[1];
    var handleChangeMeta = (0,react.useCallback)(function() {
        var _$ref, _$ref1, _$ref2;
        if ((imageRef === null || imageRef === void 0 ? void 0 : (_$ref = imageRef.current) === null || _$ref === void 0 ? void 0 : _$ref.naturalWidth) != null && (imageRef === null || imageRef === void 0 ? void 0 : (_$ref1 = imageRef.current) === null || _$ref1 === void 0 ? void 0 : _$ref1.naturalHeight) != null) props === null || props === void 0 ? void 0 : (_$ref2 = props.handleChangeMeta) === null || _$ref2 === void 0 ? void 0 : _$ref2.call(props, {
            width: imageRef.current.naturalWidth,
            height: imageRef.current.naturalHeight
        });
    }, [
        props
    ]);
    var updateLoadedState = (0,react.useCallback)(function() {
        setImageLoaded(true);
        handleChangeMeta();
    }, [
        handleChangeMeta
    ]);
    var handleImageLoaded = (0,react.useCallback)(function(result) {
        var _$ref;
        if (result.naturalWidth && result.naturalHeight) {
            setAspectRatio(result.naturalWidth / result.naturalHeight);
        }
        updateLoadedState();
        props === null || props === void 0 ? void 0 : (_$ref = props.onLoad) === null || _$ref === void 0 ? void 0 : _$ref.call(props, _objectSpreadProps(_objectSpread({}, result), {
            target: imageRef.current
        }));
    }, [
        props,
        updateLoadedState
    ]);
    var handleImageError = (0,react.useCallback)(function(e) {
        var _$ref;
        props === null || props === void 0 ? void 0 : (_$ref = props.onError) === null || _$ref === void 0 ? void 0 : _$ref.call(props, e);
    }, [
        props
    ]);
    var alreadyLoadedImageUpdateState = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        var _$ref, _$ref1;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    if (!imageLoaded && (imageRef === null || imageRef === void 0 ? void 0 : (_$ref = imageRef.current) === null || _$ref === void 0 ? void 0 : _$ref.complete)) {
                        ;
                        updateLoadedState();
                        props === null || props === void 0 ? void 0 : (_$ref1 = props.onLoad) === null || _$ref1 === void 0 ? void 0 : _$ref1.call(props, {
                            status: "alreadyLoaded"
                        });
                    }
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        imageLoaded,
        props,
        updateLoadedState
    ]);
    var calculateDimensions = (0,react.useCallback)(function() {
        if (!aspectRatio) return {};
        // w만 주어진 경우
        if (w && !h) {
            return {
                width: w,
                height: Math.round(w / aspectRatio)
            };
        }
        // h만 주어진 경우
        if (!w && h) {
            return {
                width: Math.round(h * aspectRatio),
                height: h
            };
        }
        // w, h 모두 주어진 경우 그대로 반환
        return {
            width: w,
            height: h
        };
    }, [
        w,
        h,
        aspectRatio
    ]);
    var dimensions = calculateDimensions();
    var imageUrl = (0,utils/* getResizeImage */.uU)({
        url: src && typeof src === "string" ? src : "",
        w: w ? w * imageScale : w,
        h: h ? h * imageScale : h,
        q: q,
        c: c
    });
    // next/image의 13.0.6 이전 버전은 ref를 지원하지 않기 때문에 수동으로 ref처리
    (0,react.useEffect)(function() {
        if (wrapperRef.current) {
            var imgElement = wrapperRef.current.querySelector("img");
            if (imgElement) {
                mergeRef(imgElement);
            }
        }
    }, [
        mergeRef,
        src
    ]);
    (0,react.useEffect)(function() {
        alreadyLoadedImageUpdateState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isNextImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
            position: "relative",
            width: "100%",
            height: "100%",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                ref: wrapperRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), _objectSpreadProps(_objectSpread({}, props), {
                    src: imageUrl,
                    width: dimensions.width,
                    height: dimensions.height,
                    className: className,
                    objectFit: objectFit,
                    layout: imgFit,
                    alt: props.alt || "",
                    style: {
                        borderRadius: "".concat(borderRadius, "px")
                    },
                    onLoadingComplete: handleImageLoaded,
                    onError: handleImageError,
                    unoptimized: true
                }))
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
            width: "100%",
            height: "100%",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MemorizedStyledImage, _objectSpread({
                ref: mergeRef,
                src: imageUrl,
                alt: props.alt || "",
                objectFit: objectFit,
                className: className,
                style: {
                    borderRadius: "".concat(borderRadius, "px")
                },
                onError: handleImageError
            }, props))
        })
    });
});
/* harmony default export */ var LoadImage_LoadImage = (LoadImage);
var StyledImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "LoadImage__StyledImage",
    componentId: "sc-a1dd7391-0"
})(_templateObject1(), function(param) {
    var objectFit = param.objectFit;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject(), objectFit || "cover");
});
var MemorizedStyledImage = /*#__PURE__*/ (0,react.memo)(StyledImage);

;// CONCATENATED MODULE: ./src/components/LoadImage/index.tsx
/* 작성자 : 이현우 */ 



/***/ })

}]);